import request from '@/util/request';
import qs from 'qs';
//房产树一级节点
export const getIndexInfo = (params, options) =>
  request.get(
    '/api/v4ward/nursing/index/getIndexInfo',
    Object.assign({}, options, {
      params
    })
  );